(ns practitest.frontend.forms3.entity-form.attachments
  (:require [practitest.frontend.common.i18n :refer [format-translation
                                                     get-translation]]
            [practitest.frontend.components.attachments3 :as attachments]
            [practitest.frontend.subs :as subs]
            [re-frame.core :as re-frame]))

;; Attachments
(defn- attachments-panel [{:keys [entity-type
                                  entity-id
                                  new?]
                           :as form-props}]
  (let [permissions {:can-upload? (:edit-permissions? form-props)
                     :can-preview? true
                     :can-download? true
                     :can-rename? (:edit-permissions? form-props)
                     :can-delete? (:edit-permissions? form-props)
                     :can-copy-link? true}
        {:keys [max-attachments max-attachment-size]} @(re-frame/subscribe [::subs/options])
        ;; Attachments component expects derefable `options` object, so we're wrapping it in atom
        ;; we don't need reactivity on it - so we're using plain `atom` not reagent one
        options-atom (atom {:permissions permissions
                            :max-attachments max-attachments
                            :max-attachment-size max-attachment-size})
        attachments (re-frame/subscribe (if new?
                                          [::attachments/stage-attachments entity-type]
                                          [::attachments/attachments entity-type]))
        event-options {:entity-type entity-type
                       :entity-id entity-id}]
    [attachments/attachments-view
     {:options options-atom
      :attachments attachments
      :notifications (re-frame/subscribe [::attachments/notifications entity-type])
      :entity-type entity-type
      :actions {:on-upload (fn [file]
                             (re-frame/dispatch (if new?
                                                  [::attachments/stage-upload file event-options]
                                                  [::attachments/upload file event-options])))
                :on-delete (fn [attachment]
                             (re-frame/dispatch (if new?
                                                  [::attachments/stage-delete entity-type attachment]
                                                  [::attachments/delete attachment event-options])))
                :on-rename (fn [attachment new-name]
                             (re-frame/dispatch (if new?
                                                  [::attachments/stage-rename entity-type (:id attachment) new-name]
                                                  [::attachments/rename attachment new-name event-options])))
                :on-clear-notifications #(re-frame/dispatch [::attachments/clear-notifications entity-type])
                :on-cancel-uploads #(re-frame/dispatch [::attachments/cancel-uploads entity-type])}}]))

(defn attachments-tab [edit? entity-type]
  {:tab-id :attachments
   :tab-title
   ;; NOTE: not sure whether we should make the tab titles always nowrap or not
   ;;       in the meantime will just wrap the titles in nowrap span where needed
   [:span.text-nowrap.attachments_tab
    (format-translation
     (get-translation "entity.tab.attachments" "Attachments (%{n})")
     :n (count @(re-frame/subscribe [(if edit?
                                       ::attachments/attachments
                                       ::attachments/stage-attachments)
                                     entity-type])))]
   :tab-view attachments-panel})
